import Cookies from 'js-cookie'
import setting from '@/setting'

/**
 * 获取cookie存储名称
 */
function getCookieName(name) {
  return `${setting.name}-${process.env.VUE_APP_VERSION}-${process.env.VUE_APP_BUILD_MODE}-${name}`
}

export const useCookiesUtil = {
  /**
   * 存储cookie值
   */
  set: (name = 'public', value = '', cookieSetting = {}) => {
    Cookies.set(getCookieName(name), value, Object.assign({ expires: 1 }, cookieSetting))
  },

  /**
   * 获取cookie值
   */
  get: (name = 'public') => {
    return Cookies.get(getCookieName(name))
  },

  /**
   * 获取cookie所有值
   */
  getAll: () => {
    return Cookies.get()
  },

  /**
   * 删除cookie值
   */
  remove: (name = 'public') => {
    return Cookies.remove(getCookieName(name))
  }
}
